export default __webpack_public_path__ + "static/media/illustration403.4edb103c.jpeg";